var map = {
	"./accept.svg": 1839,
	"./actions/accept.svg": 8258,
	"./actions/add.svg": 4690,
	"./actions/analyse-approve.svg": 6508,
	"./actions/attach_file.svg": 4983,
	"./actions/block.svg": 1022,
	"./actions/cancel.svg": 7930,
	"./actions/check.svg": 1247,
	"./actions/clip.svg": 5900,
	"./actions/create_questionnaire.svg": 174,
	"./actions/delete.svg": 6306,
	"./actions/edit.svg": 4787,
	"./actions/end.svg": 632,
	"./actions/give-price.svg": 8921,
	"./actions/hide.svg": 7242,
	"./actions/pdf.svg": 7030,
	"./actions/penalty.svg": 8126,
	"./actions/postpone.svg": 8000,
	"./actions/print.svg": 6504,
	"./actions/publish.svg": 1258,
	"./actions/resend.svg": 1529,
	"./actions/share.svg": 6431,
	"./actions/to_whom.svg": 1976,
	"./actions/unblock.svg": 9486,
	"./actions/update.svg": 3795,
	"./actions/view.svg": 4388,
	"./add.svg": 8112,
	"./admins.svg": 4076,
	"./arrow-down.svg": 5886,
	"./blind.svg": 2829,
	"./block.svg": 9305,
	"./cancel.svg": 5847,
	"./chat.svg": 229,
	"./circle.svg": 8023,
	"./coffee.svg": 5555,
	"./company-info.svg": 2444,
	"./delete.svg": 1734,
	"./discount.svg": 1307,
	"./doctor.svg": 7837,
	"./dots.svg": 4186,
	"./download.svg": 4958,
	"./edit.svg": 9855,
	"./email.svg": 8479,
	"./end.svg": 3315,
	"./give-price.svg": 3098,
	"./hamburger.svg": 1713,
	"./hide.svg": 6593,
	"./icon-logo.svg": 4464,
	"./locked.svg": 9854,
	"./medical_card.svg": 8974,
	"./no_image.svg": 9134,
	"./notification.svg": 312,
	"./pdf.svg": 6589,
	"./phone.svg": 9177,
	"./placemark.svg": 4082,
	"./profile.svg": 7123,
	"./rate.svg": 4635,
	"./search.svg": 1868,
	"./show-eye.svg": 4662,
	"./sidebar/about-app.svg": 4463,
	"./sidebar/about-company.svg": 3490,
	"./sidebar/analyzes.svg": 7452,
	"./sidebar/archive.svg": 13,
	"./sidebar/black-list.svg": 2355,
	"./sidebar/bonuses.svg": 7041,
	"./sidebar/category.svg": 9791,
	"./sidebar/chat.svg": 6001,
	"./sidebar/clinic.svg": 7609,
	"./sidebar/comments.svg": 483,
	"./sidebar/contacts.svg": 1098,
	"./sidebar/conversations.svg": 6341,
	"./sidebar/feedbacks.svg": 6426,
	"./sidebar/ip_telephony.svg": 6089,
	"./sidebar/list.svg": 3733,
	"./sidebar/map.svg": 4999,
	"./sidebar/medical_cards.svg": 5738,
	"./sidebar/news.svg": 5351,
	"./sidebar/one-id.svg": 4575,
	"./sidebar/orders.svg": 4923,
	"./sidebar/profession.svg": 4521,
	"./sidebar/professions.svg": 255,
	"./sidebar/promo_codes.svg": 1280,
	"./sidebar/promoted-users.svg": 6359,
	"./sidebar/questionaree.svg": 6274,
	"./sidebar/rate.svg": 3398,
	"./sidebar/reasons.svg": 5649,
	"./sidebar/registration.svg": 1533,
	"./sidebar/reports.svg": 4626,
	"./sidebar/self_employed_status.svg": 5382,
	"./sidebar/services.svg": 5071,
	"./sidebar/sms-gateway.svg": 7621,
	"./sidebar/support.svg": 2062,
	"./sidebar/symptoms.svg": 6256,
	"./sidebar/technical_support.svg": 3132,
	"./sidebar/users-by-region.svg": 6057,
	"./sidebar/users.svg": 2013,
	"./sidebar/vebinar.svg": 1688,
	"./sidebar/video-podcast.svg": 5814,
	"./sms.svg": 4900,
	"./unlocked.svg": 7848,
	"./video-call.svg": 4194,
	"./view.svg": 2861,
	"./xlsx.svg": 8692
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2498;